import type { ShareAction, ShareChannel } from '#src/app/shared/hooks/share';
import { useShareActions } from '#src/app/shared/hooks/share';

import { usePetitionShareLinks } from '../usePetitionShareLinks';
import { usePetitionShareOptions } from '../usePetitionShareOptions';

export type PetitionShareChannel = ShareChannel;
export type PetitionShareAction = ShareAction<PetitionShareChannel>;

export type PetitionShareResult = {
	shareActions: ReadonlyArray<ShareAction<PetitionShareChannel>>;
	isLoading: boolean;
};

export function usePetitionShare(): PetitionShareResult {
	const { links, isLoading } = usePetitionShareLinks();
	const options = usePetitionShareOptions();
	return { shareActions: useShareActions(links, options), isLoading };
}
